import { getQueryStringParameter } from 'owa-querystring';
const hostApp = getQueryStringParameter('hostApp');

export const CHROME_EXTENSION_ORIGIN = `chrome-extension://ajanlknhcmbhbdafadmkobjnfkhdiegm`;
export const EDGE_EXTENSION_ORIGIN = `chrome-extension://kkpalkknhlklpbflpcpkepmmbnmfailf`;
export const EDGE_OPX_HOST = `edge://outlook-hub`;
const HOST_APP_URL_MAP = {
    outlookedge: [EDGE_OPX_HOST],
    outlookextension: [CHROME_EXTENSION_ORIGIN, EDGE_EXTENSION_ORIGIN],
};
export const BROWSER_EXTENSION_ORIGINS = HOST_APP_URL_MAP[hostApp];
